var messages = {
  'en': {
    run: 'Run',
    previous: 'Previous',
    next: 'Next',
    clear: 'Clear',
    reset: 'Reset'
  },
  'zh-CN': {}
}

module.exports = messages



// WEBPACK FOOTER //
// ./src/i18n/index.js